import { ClientModel } from "./client.model";

export class ClientSignatureModel extends ClientModel implements ISignature {
    signaturePointsString?: string;
    signature?: string;
    initialsPointsString?: string;
    initials?: string;
}

export interface ISignature {
    signaturePointsString?: string;
    signature?: string;
}